'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PublikationResource = _require2.PublikationResource;

module.exports.Publikation = function (_BaseEntity) {
  _inherits(Publikation, _BaseEntity);

  _createClass(Publikation, null, [{
    key: '__name__',
    value: function __name__() {
      return 'publikation';
    }
  }]);

  function Publikation(data) {
    _classCallCheck(this, Publikation);

    var _this = _possibleConstructorReturn(this, (Publikation.__proto__ || Object.getPrototypeOf(Publikation)).call(this));

    _this._entityName = 'de.ul.fob.domain.Publikation';
    _this.band = null;
    _this.buchtitel = null;
    _this.inProjekt = null;
    _this.institution = null;
    _this.istFinal = false;
    _this.journal = null;
    _this.journalNummer = null;
    _this.publikationsTyp = null;
    _this.relevantFuerWeitere = false;
    _this.seiteEnde = null;
    _this.seiteStart = null;
    _this.serientitel = null;
    _this.sprache = null;
    _this.titelPublikation = null;
    _this.validiert = false;
    _this.verlagsort = null;
    _this.verleger = null;
    _this.veroeffentlichungsJahr = null;

    _this.author = null;
    _this.foerderer = null;
    _this.forschungsprojekt = null;
    _this.herausgeber = null;
    _this.organisationseinheit = null;
    _this.pubIdent = null;
    _this.publicPubIdent = null;
    _this.weitereOrganisationseinheiten = null;
    _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Publikation, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'band', 'buchtitel', 'inProjekt', 'institution', 'istFinal', 'journal', 'journalNummer', 'publikationsTyp', 'relevantFuerWeitere', 'seiteEnde', 'seiteStart', 'serientitel', 'sprache', 'titelPublikation', 'validiert', 'verlagsort', 'verleger', 'veroeffentlichungsJahr'],
        links: ['author', 'foerderer', 'forschungsprojekt', 'herausgeber', 'organisationseinheit', 'pubIdent', 'publicPubIdent', 'weitereOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchAuthor',
    value: function fetchAuthor() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'author');
    }
  }, {
    key: 'fetchFoerderer',
    value: function fetchFoerderer() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'foerderer');
    }
  }, {
    key: 'fetchForschungsprojekt',
    value: function fetchForschungsprojekt() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'forschungsprojekt');
    }
  }, {
    key: 'fetchHerausgeber',
    value: function fetchHerausgeber() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'herausgeber');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPubIdent',
    value: function fetchPubIdent() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'pubIdent');
    }
  }, {
    key: 'fetchPublicPubIdent',
    value: function fetchPublicPubIdent() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'publicPubIdent');
    }
  }, {
    key: 'fetchWeitereOrganisationseinheiten',
    value: function fetchWeitereOrganisationseinheiten() {
      return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'author'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'foerderer'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'forschungsprojekt'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'herausgeber'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'pubIdent'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'publicPubIdent'), _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PublikationResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Publikation.prototype.__proto__ || Object.getPrototypeOf(Publikation.prototype), 'fetchQuery', this).call(this, PublikationResource);
      }
    }
  }]);

  return Publikation;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/publikation.js
// module id = RCDp
// module chunks = 0